import React from "react";

export default function RadioCard({
  name,
  value,
  checked,
  onChange,
  title,
  description = "",
  className = "",
}) {
  return (
    <label
      className={[
        "block cursor-pointer rounded-xl border p-4 transition-all duration-150",
        checked
          ? "border-slate-900 bg-slate-900 text-white"
          : "border-slate-200 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-50",
        className,
      ].join(" ")}
    >
      <input
        className="sr-only"
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-semibold">{title}</div>
          {description ? (
            <div className={checked ? "mt-1 text-xs text-slate-200" : "mt-1 text-xs text-slate-500"}>{description}</div>
          ) : null}
        </div>
        <span
          className={[
            "mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full border text-[10px] font-semibold",
            checked ? "border-white/40 bg-white/15 text-white" : "border-slate-300 bg-white text-slate-400",
          ].join(" ")}
          aria-hidden="true"
        >
          {checked ? "?" : "?"}
        </span>
      </div>
    </label>
  );
}
